import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CreateArtifactContext } from "../../../context/CreateArtifactContext";
import { useNavigationBar } from "../../../context/NavigationContext";
import { LayoutType, SKListArtifact, ContentState } from "../../../models/SKArtifact";
import "react-datepicker/dist/react-datepicker.css";
import { AddLayoutText } from "./AddLayoutText";
import { AddLayoutTable } from "./AddLayoutTable";
import { isEditable } from "@testing-library/user-event/dist/utils";

export default function AddList() {
  const { contentData, artifactId, updateContentData, loading, saveData, isEditable } = useContext(CreateArtifactContext);
  const { setNavProps } = useNavigationBar();
  const navigate = useNavigate();
  const [editable, setEditable] = useState<boolean>(true);
  const [isValidForm, setIsValidForm] = useState(false);
  const [listData, setListData] = useState<SKListArtifact | undefined>(undefined);
  const [layout, setLayout] = useState(LayoutType.table);

  useEffect(() => {
    const validate = async () => {
      try {
        if ((contentData as SKListArtifact).listItems != null) {
          setIsValidForm(true);
        }
      } catch (err) {
        setIsValidForm(false);
      }
    };
    validate();
  }, [contentData]);

  useEffect(() => {
    if (contentData.status === ContentState.DRAFT) {
      setEditable(true);
    } else {
      setEditable(false);
    }
  }, [contentData]);

  useEffect(() => {
    setNavProps(prev => ({
      ...prev,
      backArrow: false,
      buttonTitle: "Done",
      title: "Add List",
      enableLink: isEditable ? isValidForm : false,
      getActionItems: undefined,
      onNext: isEditable ? submit : undefined,
      onClose: () => navigate(-1),
      onEdit: undefined,
    }));
  }, [setNavProps, listData, isEditable]);

  useEffect(() => {
    setListData(contentData as SKListArtifact);
  }, [contentData]);

  const submit = async () => {
    await saveData();
    window.history.back();
  };

  useEffect(() => {
    setLayout((contentData as SKListArtifact).layout);
  }, [contentData]);

  return (
    <>
      <div className="flex flex-col gap-[30px] mt-[12px]">
        {layout === LayoutType.text && <AddLayoutText />}
        {(layout === LayoutType.table || layout === LayoutType.coulmn || layout === LayoutType.grid) && <AddLayoutTable />}
      </div>
    </>
  );
}
